import React, { useState } from "react";
import "./Enquiry.css";
import { MdCancel } from "react-icons/md";

const Slide = () => {
  const [isDemoOptionOpen, setDemoOptionOpen] = useState(false);

  const handleQuickOptionClick = () => {
    setDemoOptionOpen(!isDemoOptionOpen);
  };
  const [selectedSoftware, setSelectedSoftware] = useState([]);
  const [softwareSearch, setSoftwareSearch] = useState("");
  const [showSoftwareOptions, setShowSoftwareOptions] = useState(false);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("Submit");

  const [info, setInfo] = useState({
    name: "",
    mobilenumber: "",
    email: "",
    selectedOption: "",
    subOption: "",
    course: "", // Add this
    software: [],
  });
  const getFilteredSoftware = () => {
    if (!info.course || !softwareOptions[info.course]) return [];

    return softwareOptions[info.course].filter((software) =>
      software.toLowerCase().includes(softwareSearch.toLowerCase())
    );
  };

  const handleSoftwareChange = (software, isChecked) => {
    if (isChecked) {
      setSelectedSoftware((prev) => [...prev, software]);
    } else {
      setSelectedSoftware((prev) => prev.filter((s) => s !== software));
    }

    // Clear software error if any software is selected
    if (errors.software && (isChecked || selectedSoftware.length > 1)) {
      setErrors((prev) => ({ ...prev, software: "" }));
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;

    setInfo({
      ...info,
      [name]: value,
    });

    // If category is changed, reset course and software selections
    if (name === "selectedOption") {
      setInfo((prev) => ({
        ...prev,
        [name]: value,
        course: "", // Reset course when category changes
        software: [], // Reset software when category changes
      }));
      setShowSoftwareOptions(false);
      setSelectedSoftware([]);
      setSoftwareSearch("");
      setErrors((prev) => ({ ...prev, software: "" }));
    }

    // If course is changed, show/hide software options and reset selections
    if (name === "course") {
      setShowSoftwareOptions(!!value);
      setSelectedSoftware([]);
      setSoftwareSearch("");
      setErrors((prev) => ({ ...prev, software: "" }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(info);
    if (info.course && selectedSoftware.length === 0) {
      setErrors((prev) => ({
        ...prev,
        software: "Please select at least one software",
      }));
      return;
    }

    setStatus("Sending...");

    let response = await fetch(`/api/inquiry`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        //'Content-Type': 'application/json',
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        ...info,
        software: selectedSoftware, // This will now be included
      }),
      //body: JSON.stringify(details),
    });
    //console.log(details);
    console.log(info);
    setStatus("Submit");
    setInfo({
      name: "",
      mobilenumber: "",
      email: "",
      selectedOption: "", // Reset category
      subOption: "",
      course: "",
      software: [],
    });
    let result = await response.json();
    //alert(result.status);
  };
  // const getOptions = () => {
  //   switch (info.selectedOption) {
  //     case "Mechanical":
  //       return [
  //         "AUTOCAD",
  //         "Catia V5",
  //         "NXCAD",
  //         "CREO",
  //         "AUTO INVENTOR",
  //         "ANSYS",
  //         "REVIT MEP",
  //         "CNC",
  //         "ART CAM",
  //         "NX CAM",
  //       ];
  //     case "Civil":
  //       return [
  //         "AUTOCAD",
  //         "REVIT ARCH",
  //         "SKETCH UP",
  //         "REVIT STRU",
  //         "V-RAYS",
  //         "LUMION",
  //         "STAAD PRO",
  //         "ETAB",
  //         "CIVIL 3D",
  //         "PRIMAVERA",
  //       ];
  //     case "Electrical":
  //       return [
  //         "AUTOCAD",
  //         "AUTO ELECTRICal",
  //         "EPLAN",
  //         "MATLAB",
  //         "PLC",
  //         "SCADA",
  //       ];
  //     case "Computer":
  //       return [
  //         " C/C++",
  //         "MS-OFFICE",
  //         "TALLY",
  //         "PHOTOSHOP",
  //         "DCA",
  //         "PGDCAA",
  //         "ADVANCE PGDCAA",
  //       ];

  //     default:
  //       return [];
  //   }
  // };

  const coursesByCategory = {
    Mechanical: [
      "MECHANICAL",
      "DIPLOMA MECH CAD",
      "PROFESSIONAL MECH CAD",
      "Certificate Course on Mechanical CAD",
      "Professional in Automotive Design",
      "Professional in Manufacturing Technology",
    ],
    Civil: [
      "CIVIL & ARCH",
      "DIPLOMA CIVIL CAD",
      "PROFESSIONAL CIVIL CAD",
      "Certificate Course on Civil CAD",
      "INTERIOR DESIGNING",
      "Certificate Course on BIM",
      "Diploma on BIM",
      "Professional Course on BIM",
          "Professional in Structural Design",
"Diploma in Structural Design",
"Certificate course on Structural Design",
    ],
    Electrical: [
      "ELECTRICAL",
      "DIPLOMA ELECTRICAL CAD",
      "PROFESSIONAL ELECTRCIAL CAD",
      "Certificate Course on Electrical CAD",
    ],
    Computer: [
      "DCA",
      "PGDCA",
      "ADVANCE PGDCA",
      "IT & CS",
      "MS OFFICE",
      "ADVANCE EXCEL",
      "BASIC COMPUTER",
      "PHOTOSHOP",
      "TALLY",
    ],
  };

  // 2. Add this function to get courses based on selected category
  const getCoursesForCategory = () => {
    if (!info.selectedOption) return [];
    return coursesByCategory[info.selectedOption] || [];
  };

  const courses = [
    "ADVANCE EXCEL",
    "ADVANCE PGDCA",
    "Certificate Course on Electrical CAD",
    "Certificate Course on Civil CAD",
    "Certificate Course on Mechanical CAD",
    "BASIC COMPUTER",
    "CIVIL & ARCH",
    "DIPLOMA CIVIL CAD",
    "DIPLOMA ELECTRICAL CAD",
    "DIPLOMA MECH CAD",
    "DCA",
    "ELECTRICAL",
    "IT & CS",
    "INTERIOR DESIGNING",

    "MECHANICAL",
    "MS OFFICE",
    "PGDCA",
    "PROFESSIONAL CIVIL CAD",
    "PROFESSIONAL ELECTRCIAL CAD",
    "PROFESSIONAL MECH CAD",

    "PHOTOSHOP",
    "TALLY",
  ];
  const courseIdentifiers = {
    DCA: "DCA",
    "ADVANCE PGDCA": "APG",
    PGDCA: "PG",
    MECHANICAL: "MCAD",
    ELECTRICAL: "ECAD",
    "CIVIL & ARCH": "ACAD",
    "IT & CS": "IT",
    TALLY: "TY",
    PHOTOSHOP: "PS",
    "MS OFFICE": "MSO",
    "ADVANCE EXCEL": "AE",
    "BASIC COMPUTER": "BC",
    "DIPLOMA MECH CAD": "DMCAD",
    "PROFESSIONAL MECH CAD": "PMCAD",
    "DIPLOMA CIVIL CAD": "DACD",
    "PROFESSIONAL CIVIL CAD": "PACAD",
    "DIPLOMA ELECTRICAL CAD": "DECAD",
    "PROFESSIONAL ELECTRCIAL CAD": "PECAD",
    "INTERIOR DESIGNING": "IAD",
  };

  const softwareOptions = {
    "ADVANCE EXCEL": ["Microsoft Excel"],
    "ADVANCE PGDCA": [
      "Computer Fundamental",
      "Ms-DOS & Windows",
      "MS Office",
      "Internet",
      "Paint",
      "Notepad",
      "WordPad",
      "C",
      "C++",
      "HTML",
      "TALLY",
    ],
    "BASIC COMPUTER": [
      "Paint",
      "Notepad",
      "WordPad",
      "Basic MS Office",
      "MS Office",
      "C",
      "C++",
      "HTML",
      "TALLY",
      "Ms DOs & Windows",
      "Internet",
    ],
    "Certificate Course on Mechanical CAD": [
      "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],
    "Certificate Course on Civil CAD": [
      "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],
    "Certificate course on Structural Design":[ "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"],
      "Diploma in Structural Design":[ "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"],
      "Professional in Structural Design":[ "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"], 
    "Certificate Course on Electrical CAD": [
      "Auto CAD Electrical",
      "Eplan",
      "Matlab",
      "PLC",
      "SCADA",
      "Revit MEP",
    ],
     "Certificate Course on BIM" :[
          "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Revit MEP",
      "Naviswork",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],
    
    "Diploma on BIM" :[
        "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Revit MEP",
      "Naviswork",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],

    "Professional Course on BIM" :[
         "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Revit MEP",
      "Naviswork",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],


     "Professional in Automotive Design" : [
         "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],

    "Professional in Manufacturing Technology" : [
          "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],


    "CIVIL & ARCH": [
      "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],
    DCA: [
      "Paint",
      "Notepad",
      "WordPad",
      "MS Office",
      "C",
      "C++",
      "HTML",
      "TALLY",
      "Ms DOs & Windows",
      "Internet",
      "Software Hacking and IT Security",
      "ER Basics",
      "E-Business",
    ],
    "DIPLOMA CIVIL CAD": [
      "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],
    "DIPLOMA ELECTRICAL CAD": [
      "Auto CAD Electrical",
      "Eplan",
      "Matlab",
      "PLC",
      "SCADA",
      "Revit MEP",
    ],
    "DIPLOMA MECH CAD": [
      "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],
    ELECTRICAL: [
      "Auto CAD Electrical",
      "Eplan",
      "Matlab",
      "PLC",
      "SCADA",
      "Revit MEP",
    ],
    "INTERIOR DESIGNING": [
      "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)",
      "Photshop"
    ],
    "IT & CS": ["C", "C++", "Java", "Python", "Power BI"],
    MECHANICAL: [
      "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],
    "MS OFFICE": ["Microsoft Word", "Microsoft Excel", "Microsoft PowerPoint"],
    PGDCA: [
      "Computer Fundamental",
      "Ms-DOS & Windows",
      "MS Office",
      "Internet",
      "Paint",
      "Notepad",
      "WordPad",
      "C",
      "C++",
      "HTML",
      "TALLY",
    ],
    PHOTOSHOP: [
      "Basics of Photoshop",
      "Image Editing",
      "Layer Management",
      "Working with Paths",
    ],
    "PROFESSIONAL CIVIL CAD": [
      "Auto CAD",
      "Revit Architecture",
      "Revit Structure",
      "Sketch up",
      "3Ds Max",
      "Vray",
      "Enscape",
      "Lumion",
      "Tekla",
      "Quantity Take Off",
      "Staad Pro",
      "ETAB",
      "PRIMAVERA",
      "Tekla Structure", "RCDC", "Autodesk Civil 3D", "MS Project",  "OpenRoads", "SAFE(Foundation Design)","Photshop"
    ],
    "PROFESSIONAL ELECTRCIAL CAD": [
      "Auto CAD Electrical",
      "Eplan",
      "Matlab",
      "PLC",
      "SCADA",
      "Revit MEP",
    ],
    "PROFESSIONAL MECH CAD": [
      "Auto CAD",
      "Solidworks",
      "Catia V5",
      "NX CAD",
      "Autodesk Inventor",
      "Ansys Workbench",
      "CNC",
      "GD & T",
      "Revit MEP",
      "Art CAM",
    ],
    TALLY: ["Company Creation", "Accounting Features", "Inventory Management"],
  };

  const nameRegex = /^[a-zA-Z\s]+$/;
  const phoneRegex = /^\d{10}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleNameChange = (e) => {
    const inputValue = e.target.value;
    if (nameRegex.test(inputValue) || inputValue === "") {
      info.name(inputValue);
    }
  };

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    if (phoneRegex.test(inputValue) || inputValue === "") {
      info.phone(inputValue);
    }
  };

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    if (emailRegex.test(inputValue) || inputValue === "") {
      info.email(inputValue);
    }
  };

  return (
    <>
      <div
        className={`demo-option-container ${isDemoOptionOpen ? "open" : ""}`}
      >
        <div className="aeroland__toolbar">
          <div
            className="inner"
            style={{ background: "orange", textAlign: "right" }}
          >
            <button
              className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
              style={{
                color: "White",
                transform: `rotate(180deg) ${
                  isDemoOptionOpen ? "rotate(90deg)" : "rotate(90deg)"
                }`,
                fontSize: "18px", // Adjust the font size as needed
                border: "none",
                // Remove the border
                background: "transparent",
                fontWeight: "bold",
                outline: "none" /* Remove default focus outline */,
                border: "none",
                // Optional: Adjust the negative margin to fine-tune the vertical position
                marginLeft: "-28px",
                lineHeight: "8.15",
                color: "black",
                textAlign: "center",
                marginTop: "-37px",
              }}
              onClick={handleQuickOptionClick}
            >
              Inquiry
            </button>
          </div>
        </div>

        <div className="demo-option-wrapper">
          <button
            className="quick-option hint--bounce hint--left hint--black primary-color-hover-important"
            onClick={handleQuickOptionClick}
            style={{ backgroundColor: "#FFB237" }}
          >
            <MdCancel style={{ fontSize: "40px" }} />
          </button>

          <div className="business-solution-form-wrap mr-auto ml-auto">
            <div className="contact-title text-center section-space--mb_40">
              <b>
                <h3 className="mb-10">Contact Us</h3>
              </b>
            </div>

            <form id="applyOnlyEnqury" onSubmit={handleSubmit}>
              <input type="hidden" name="valid" value="false" />
              <div class="contact-form__two">
                <br />

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="name"
                    type="text"
                    placeholder="Name *"
                    required
                    id="name"
                    pattern="[a-zA-Z\s]+"
                    title="Please enter only alphabets"
                    value={info.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="email"
                    type="text"
                    placeholder="Email id *"
                    required
                    id="email"
                    pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                    title="Please enter a valid email address"
                    value={info.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="contact-inner" style={{ width: "260px" }}>
                  <input
                    name="mobilenumber"
                    type="text"
                    placeholder="Contact No *"
                    required
                    id="mobilenumber"
                    pattern="\d{10}"
                    title="Please enter a 10-digit phone number"
                    value={info.mobilenumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-3">
                  <select
                    className="form-control p-3 border-0"
                    value={info.selectedOption || ""}
                    name="selectedOption"
                    required
                    onChange={handleChange}
                  >
                    <option value="">Select Category</option>
                    <option value="Mechanical">Mechanical</option>
                    <option value="Civil">Civil</option>
                    <option value="Electrical">Electrical</option>
                    <option value="Computer">Computer</option>
                  </select>
                </div>
                {/* <div className="mb-3">
                  {info.selectedOption && (
                    <select
                      className="form-control p-3 border-0"
                      required
                      name="subOption"
                      value={info.subOption}
                      onChange={handleChange}
                    >
                      <option value="">Select {info.selectedOption}</option>
                      {getOptions().map((subOption) => (
                        <option key={subOption} value={subOption}>
                          {subOption}
                        </option>
                      ))}
                    </select>
                  )}
                </div> */}
                <div className="contact-inner">
                  <select
                    className="gen"
                    name="course"
                    value={info.course}
                    onChange={handleChange}
                    required
                    disabled={!info.selectedOption} // Disable if no category selected
                    style={{
                      backgroundColor: info.selectedOption
                        ? "white"
                        : "#f5f5f5",
                      color: "rgb(0 1 0)",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "260px",
                      marginLeft: "-110px",
                    }}
                  >
                    <option value="">
                      {info.selectedOption
                        ? `Select ${info.selectedOption} Course`
                        : "Select Category First"}
                    </option>
                    {getCoursesForCategory().map((course, index) => (
                      <option key={index} value={course}>
                        {course}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="contact-inner" style={{ marginLeft: "80px" }}>
                  {showSoftwareOptions && (
                    <div>
                      <div style={{ width: "300px", marginLeft: "-90px" }}>
                        Select Software for {info.course} (minimum 1 required):
                      </div>

                      {/* Search Input */}
                      <input
                        type="text"
                        placeholder="Search software..."
                        value={softwareSearch}
                        onChange={(e) => setSoftwareSearch(e.target.value)}
                        style={{
                          backgroundColor: "white",
                          color: "rgb(0 1 0)",
                          padding: "10px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          width: "260px",
                          marginLeft: "-110px",
                        }}
                      />

                      {/* Software Checkboxes */}
                      <div
                        style={{
                          maxHeight: "200px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "10px",
                          backgroundColor: "white",
                          width: "220px",
                          marginLeft: "-70px",
                        }}
                      >
                        {getFilteredSoftware().map((software, index) => (
                          <label
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "8px",
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                          >
                            <input
                              type="checkbox"
                              value={software}
                              checked={selectedSoftware.includes(software)}
                              onChange={(e) =>
                                handleSoftwareChange(software, e.target.checked)
                              }
                              style={{
                                marginRight: "8px",
                                height: "20px",
                                width: "20px",
                              }}
                            />
                            {software}
                          </label>
                        ))}

                        {getFilteredSoftware().length === 0 && (
                          <p
                            style={{
                              color: "#666",
                              fontSize: "14px",
                              margin: "10px 0",
                            }}
                          >
                            No software found matching your search.
                          </p>
                        )}
                      </div>

                      {errors.software && (
                        <p
                          className="error"
                          style={{ color: "red", fontSize: "12px" }}
                        >
                          {errors.software}
                        </p>
                      )}

                      {selectedSoftware.length > 0 && (
                        <div style={{ marginTop: "10px", fontSize: "14px" }}>
                          <strong>Selected:</strong>{" "}
                          {selectedSoftware.join(", ")}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <br />

                <div
                  class="comment-submit-btn text-center"
                  style={{ color: "#ffc107" }}
                >
                  <button
                    class="ht-btn ht-btn-md"
                    type="submit"
                    name="submitEnqury"
                    id="submitEnqury"
                    style={{ backgroundColor: "#ffc107" }}
                  >
                    Submit
                  </button>
                  {/* <!--  <p class="form-messege"></p> --> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default Slide;
